module.exports = __webpack_public_path__ + "static/repair_module-35fdc919308c9e2ea05f605ffa63e4c3.jpg";